import { Injectable } from '@angular/core';
import { IntegrationProviderEnum, Uuid } from '../../../../../graphql';
import { IntegrationProvider } from '../../../../data/models/integrations.model';
import { InvoicingApiService } from './domain/api/invoicing.api.service';

@Injectable({ providedIn: 'root' })
export class InvoicingService {
    constructor(private api: InvoicingApiService) {}

    syncExternalInvoicePayments(jobId: Uuid, provider: IntegrationProvider) {
        return this.api.syncExternalInvoicePayments(jobId, this.#providerToProviderEnum(provider));
    }

    #providerToProviderEnum(provider: IntegrationProvider) {
        switch (provider) {
            case IntegrationProvider.Xero:
                return IntegrationProviderEnum.Xero;
            case IntegrationProvider.QuickBooks:
                return IntegrationProviderEnum.Quickbooks;
            case IntegrationProvider.MYOB:
                return IntegrationProviderEnum.Myob;
            case IntegrationProvider.Deputy:
                return IntegrationProviderEnum.Deputy;
            case IntegrationProvider.QuickbooksTimesheets:
                return IntegrationProviderEnum.Quickbookstimesheets;
        }
    }
}
